import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { premiumTheme } from "./theme/premiumTheme";
import ErrorBoundary from "./components/ErrorBoundary";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";
import { ScrollToTopButton } from "./components/ScrollToTopButton";
import "./App.css";
import "@fontsource/roboto/300.css"; // Roboto Light
import "@fontsource/roboto/400.css"; // Roboto Regular
import "@fontsource/roboto/500.css"; // Roboto Medium
import "@fontsource/roboto/700.css"; // Roboto Bold

// Lazy load route components for better performance
const Home = lazy(() => import("./containers/Home"));
const About = lazy(() => import("./containers/About"));
const Services = lazy(() => import("./containers/Services"));
const Training = lazy(() => import("./containers/Training"));
const Insights = lazy(() => import("./containers/Insights"));
const Resources = lazy(() => import("./containers/Resources"));
const AdminLogin = lazy(() => import("./containers/AdminLogin"));
const NotFound = lazy(() => import("./containers/NotFound"));

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={premiumTheme}>
        <CssBaseline />
        <ErrorBoundary>
          <Router>
            <ScrollToTop />
            <div className="App premium-app">
              <ErrorBoundary>
                <Navigation />
              </ErrorBoundary>
              <main className="premium-main">
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <ErrorBoundary>
                          <Home />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/about"
                      element={
                        <ErrorBoundary>
                          <About />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/services"
                      element={
                        <ErrorBoundary>
                          <Services />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/training"
                      element={
                        <ErrorBoundary>
                          <Training />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/insights"
                      element={
                        <ErrorBoundary>
                          <Insights />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/resources"
                      element={
                        <ErrorBoundary>
                          <Resources />
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/admin"
                      element={
                        <ErrorBoundary>
                          <AdminLogin />
                        </ErrorBoundary>
                      }
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </main>
              <ErrorBoundary>
                <Footer />
              </ErrorBoundary>
              <ScrollToTopButton />
            </div>
          </Router>
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
